<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function () {
    // Check if the screen width is less than or equal to 768px (mobile devices)
    let imageSrc = window.innerWidth <= 768 
        ? "https://securepay.sslcommerz.com/public/image/SSLCommerz-Pay-With-logo-All-Size-04.png" // Mobile image
        : "https://securepay.sslcommerz.com/public/image/SSLCommerz-Pay-With-logo-All-Size-01.png"; // Desktop image

    // Create the image element
    let img = document.createElement("img");
    img.src = imageSrc;
    img.style.maxWidth = "95%";
    img.style.margin = "auto";
    img.style.marginBottom = "20px";

    // Find the target element
    let target = document.querySelector(".footer__content-bottom .container-1370");

    // Insert the image as the first child if the element exists
    if (target) {
        target.insertBefore(img, target.firstChild);
    }
});

